import store from '../store'

export default{
    libelle(idOptionInterface) {
        if (!idOptionInterface) return ''
        let libOptionInterface = store.getters.getLibelleOptionInterface(idOptionInterface)
        if (!libOptionInterface) return ''
        return libOptionInterface
    }
}